import type { ReactNode } from 'react';

interface HomeGreetingProps {
  firstName: string | null;
  action?: ReactNode;
}

export function HomeGreeting({ firstName, action }: HomeGreetingProps) {
  return (
    <div className="mb-4 -mx-4 relative">
      {/* Gradient background positioned at bottom */}
      <div
        className="absolute inset-x-0 bottom-0 h-32 bg-contain bg-center bg-no-repeat pr-12"
        style={{ backgroundImage: "url('/assets/images/gradient-banner.svg')" }}
        aria-hidden="true"
      />
      {/* Text content */}
      <div className="relative z-10 px-4 py-6 flex items-start justify-between gap-4">
        <div>
          <span className="text-lead">Hi,</span>
          <h1 className="font-field-74 text-h1 text-slate-50 leading-[45px]">
            {firstName}
          </h1>
        </div>
        {action}
      </div>
    </div>
  );
}
